import { ProductIcons } from './ProductIcons'

export default ProductIcons
